import { CustomisationKey } from "@scenes/pdp/types";

export const calculatedWidth = (screenDivision: number, key: string) => {
  if (
    key === CustomisationKey.price ||
    key === CustomisationKey.discount_percent
  ) {
    return 50;
  } else if (key === CustomisationKey.total_sales_price) {
    return screenDivision + 50;
  } else {
    return screenDivision - 20;
  }
};
